<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">
            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a document about DP capability" (click)="create()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <ng-container matColumnDef="capability_plot_name">
                <th mat-header-cell *matHeaderCellDef> Capability Plot </th>
                <td mat-cell *matCellDef="let element"> {{element.capability_plot_name}} </td>
            </ng-container>

            <ng-container matColumnDef="capability_plot_remark">
                <th mat-header-cell *matHeaderCellDef> Plot Rremark </th>
                <td mat-cell *matCellDef="let element"> {{element.capability_plot_remark}} </td>
            </ng-container>

            <ng-container matColumnDef="verifying_footprint_name">
                <th mat-header-cell *matHeaderCellDef> Verifying Footprint </th>
                <td mat-cell *matCellDef="let element"> {{element.verifying_footprint_name}} </td>
            </ng-container>

            <ng-container matColumnDef="verifying_footprint_remark">
                <th mat-header-cell *matHeaderCellDef> Footprint Remark </th>
                <td mat-cell *matCellDef="let element"> {{element.verifying_footprint_remark}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailDocumentCapability(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>

